// extracted by mini-css-extract-plugin
module.exports = {"title":"hb2LYF","text":"_1tJBJO","image":"DVt4gj","planItems":"_2Ez6-j","label":"o8BMjs","actions":"MAMdUj","button":"_2bBKW7","planItem":"UcbeKv"};